export default __webpack_public_path__ + "static/media/tableWare.5deb5ee2.svg";